import {
  Grid,
  Typography,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import SectionCard from "./SectionCard";
import SectionHeader from "./SectionHeader";
import { ACTIVIDADES_LIST } from "../hooks/useEntrevistaData";

const handleInputChange = (setter) => (e) => setter(e.target.value);

const textFieldSx = { fontSize: "small" };

export default function EntrevistaEdit({ state, sectionRefs, sectionCardSx }) {
  const {
    codigo,
    createdAt,
    tipoEntrevista, setTipoEntrevista,
    nombre, setNombre,
    apellidos, setApellidos,
    telefono, setTelefono,
    dateBirth, setDateBirth,
    numViven, setNumViven,
    numGrupo, setNumGrupo,
    numNivelEducacional, setNumNivelEducacional,
    numSexo, setNumSexo,
    edad, setEdad,
    venredi, setVenredi,
    terapiaOcupacional, setTerapiaOcupacional,
    numFumador, setNumFumador,
    numAlcohol, setNumAlcohol,
    caidas12Meses, setCaidas12Meses,
    numCaidas, setNumCaidas,
    ayudaLocomocion, setAyudaLocomocion,
    protesisArticulares, setProtesisArticulares,
    protesisRodilla, setProtesisRodilla,
    protesisCadera, setProtesisCadera,
    protesisHombro, setProtesisHombro,
    protesisManoDedos, setProtesisManoDedos,
    protesisOtros, setProtesisOtros,
    vertigos, setVertigos,
    mareosAndar, setMareosAndar,
    cardiovascular, setCardiovascular,
    hipertension, setHipertension,
    insuficienciaCardiaca, setInsuficienciaCardiaca,
    accCerebrovascular, setAccCerebrovascular,
    anginaPecho, setAnginaPecho,
    infarto, setInfarto,
    trombosis, setTrombosis,
    otrosCardiovascular, setOtrosCardiovascular,
    respiratorio, setRespiratorio,
    asma, setAsma,
    epoc, setEpoc,
    otrosRespiratorio, setOtrosRespiratorio,
    genitoUrinario, setGenitoUrinario,
    infeccionUrinaria, setInfeccionUrinaria,
    calculosRenales, setCalculosRenales,
    insuficienciaRenal, setInsuficienciaRenal,
    incontinenciaUrinaria, setIncontinenciaUrinaria,
    prostata, setProstata,
    otrosGenitoUrinario, setOtrosGenitoUrinario,
    endocrino, setEndocrino,
    diabetes, setDiabetes,
    hipotiroidismo, setHipotiroidismo,
    hipercolesterolemia, setHipercolesterolemia,
    osteoporosis, setOsteoporosis,
    otrosEndocrino, setOtrosEndocrino,
    digestivo, setDigestivo,
    herniaHiato, setHerniaHiato,
    reflujo, setReflujo,
    pancreatitis, setPancreatitis,
    enfermedadHepatica, setEnfermedadHepatica,
    diverticulitis, setDiverticulitis,
    otrosDigestivo, setOtrosDigestivo,
    musculoEsqueletico, setMusculoEsqueletico,
    pieTobillo, setPieTobillo,
    rodilla, setRodilla,
    cadera, setCadera,
    lumbar, setLumbar,
    dorsal, setDorsal,
    cervical, setCervical,
    cabeza, setCabeza,
    hombro, setHombro,
    codo, setCodo,
    manoMunieca, setManoMunieca,
    nervioso, setNervioso,
    depresion, setDepresion,
    ansiedad, setAnsiedad,
    esclerosisMultiple, setEsclerosisMultiple,
    parkinson, setParkinson,
    alzheimer, setAlzheimer,
    deterioroCognitivo, setDeterioroCognitivo,
    neuropatiaPeriferica, setNeuropatiaPeriferica,
    otrosNervioso, setOtrosNervioso,
    sentidos, setSentidos,
    hipoacusia, setHipoacusia,
    tinitus, setTinitus,
    perdidaVision, setPerdidaVision,
    datosInteres, setDatosInteres,
    numAnalgesicos, setNumAnalgesicos,
    medicacion, setMedicacion,
    antihipertensivos, setAntihipertensivos,
    antidiabeticos, setAntidiabeticos,
    estatinas, setEstatinas,
    anticoagulantes, setAnticoagulantes,
    tiroides, setTiroides,
    diuretico, setDiuretico,
    analgesicos, setAnalgesicos,
    antidepresivos, setAntidepresivos,
    ansioliticos, setAnsioliticos,
    antiosteoporoticos, setAntiosteoporoticos,
    inhalador, setInhalador,
    protectorEstomago, setProtectorEstomago,
    otrosMedicacion, setOtrosMedicacion,
    tensionPAS, setTensionPAS,
    tensionPAD, setTensionPAD,
    tensionPMM, setTensionPMM,
    actividades, setActividades,
    actividadesExtras,
    actividadesSeleccionadas,
    caidasFinales, setCaidasFinales,
    numPastillas, setNumPastillas,
    numAnalgesicosFinal, setNumAnalgesicosFinal,
    cambioMedicacionFinal, setCambioMedicacionFinal,
    consultaMedico, setConsultaMedico,
    ingresosHospital, setIngresosHospital,
    datosInteresFinal, setDatosInteresFinal,
  } = state;

  return (
    <>
      {/* Bloque 1: Datos del paciente */}
      <SectionCard
        className="entrevista-viewer__section is-editing"
        ref={(node) => { sectionRefs.current.datos = node; }}
        sx={sectionCardSx}
      >
        <SectionHeader
          eyebrow="Bloque 1"
          title="Datos del paciente"
          description="Identificación, contexto sociodemográfico y situación basal del paciente."
        />

        <Grid container spacing={2} sx={{ marginBottom: 4, marginTop: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="CÓDIGO" variant="outlined" fullWidth value={codigo} InputProps={{ readOnly: true }} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="FECHA" variant="outlined" fullWidth value={createdAt} InputProps={{ readOnly: true }} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="TIPO" select fullWidth value={tipoEntrevista} onChange={(e) => setTipoEntrevista(e.target.value)} sx={textFieldSx} size="small">
              <MenuItem value="Inicial">Inicial (Septiembre)</MenuItem>
              <MenuItem value="Final">Final (Junio)</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} md={4}>
            <TextField label="NOMBRE" variant="outlined" fullWidth value={nombre} onChange={handleInputChange(setNombre)} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="APELLIDOS" variant="outlined" fullWidth value={apellidos} onChange={handleInputChange(setApellidos)} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="TELÉFONO" variant="outlined" fullWidth value={telefono} onChange={handleInputChange(setTelefono)} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} md={4}>
            <TextField label="FECHA DE NACIMIENTO (dd-mm-yyyy)" variant="outlined" fullWidth value={dateBirth} onChange={handleInputChange(setDateBirth)} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="VIVEN" select fullWidth value={numViven} onChange={(e) => setNumViven(e.target.value)} sx={textFieldSx} size="small">
              <MenuItem value={0}>Solo</MenuItem>
              <MenuItem value={1}>Pareja</MenuItem>
              <MenuItem value={2}>Familiares</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="GRUPO" select fullWidth value={numGrupo} onChange={(e) => setNumGrupo(e.target.value)} sx={textFieldSx} size="small">
              <MenuItem value={1}>Pizarrales</MenuItem>
              <MenuItem value={2}>Amis</MenuItem>
              <MenuItem value={3}>Tierra charra</MenuItem>
              <MenuItem value={4}>María Auxiliadora</MenuItem>
              <MenuItem value={5}>Juan de la Fuente</MenuItem>
              <MenuItem value={6}>Buenos aires</MenuItem>
              <MenuItem value={7}>Tejares</MenuItem>
              <MenuItem value={8}>Chamberí</MenuItem>
              <MenuItem value={9}>San Isidro</MenuItem>
              <MenuItem value={10}>Puente Ladrillo</MenuItem>
              <MenuItem value={11}>La Vega</MenuItem>
              <MenuItem value={12}>San José</MenuItem>
              <MenuItem value={13}>Otro</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} md={4}>
            <TextField label="NIVEL EDUCACIONAL" select fullWidth value={numNivelEducacional} onChange={(e) => setNumNivelEducacional(e.target.value)} sx={textFieldSx} size="small">
              <MenuItem value={0}>Analfabeto</MenuItem>
              <MenuItem value={1}>Estudios primarios incompletos</MenuItem>
              <MenuItem value={2}>Estudios primarios</MenuItem>
              <MenuItem value={3}>Estudios secundarios</MenuItem>
              <MenuItem value={4}>Otros</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="SEXO" select fullWidth value={numSexo} onChange={(e) => setNumSexo(e.target.value)} sx={textFieldSx} size="small">
              <MenuItem value={1}>Hombre</MenuItem>
              <MenuItem value={2}>Mujer</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="EDAD" variant="outlined" fullWidth value={edad} onChange={handleInputChange(setEdad)} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ marginBottom: 2, textAlign: { xs: "left", sm: "center" }, mt: 2 }}>
          PROGRAMAS QUE PARTICIPA
        </Typography>

        <Grid container spacing={1} sx={{ marginBottom: 2, paddingLeft: 0, marginLeft: 0.3 }}>
          <Grid item xs="auto">
            <FormControlLabel
              control={<Checkbox checked={venredi} onChange={(e) => setVenredi(e.target.checked)} />}
              label="VENREDI"
            />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel
              control={<Checkbox checked={terapiaOcupacional} onChange={(e) => setTerapiaOcupacional(e.target.checked)} />}
              label="TERAPIA OCUPACIONAL"
            />
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ marginBottom: 2, textAlign: { xs: "left", sm: "center" }, mt: 2 }}>
          HÁBITOS NOCIVOS
        </Typography>

        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} md={6}>
            <TextField label="FUMADOR" select fullWidth value={numFumador} onChange={(e) => setNumFumador(e.target.value)} sx={textFieldSx} size="small">
              <MenuItem value={1}>No</MenuItem>
              <MenuItem value={2}>Sí</MenuItem>
              <MenuItem value={3}>Fue fumador</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} md={6}>
            <TextField label="ALCOHOL" select fullWidth value={numAlcohol} onChange={(e) => setNumAlcohol(e.target.value)} sx={textFieldSx} size="small">
              <MenuItem value={1}>No</MenuItem>
              <MenuItem value={2}>Sí</MenuItem>
              <MenuItem value={3}>Consumía Alcohol</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ marginBottom: 2, textAlign: "center" }}>HISTORIAL</Typography>
        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Caídas</Typography>

        <Grid container spacing={1} sx={{ marginBottom: 2, paddingLeft: 0, marginLeft: 0.3 }}>
          <Grid item xs="auto">
            <FormControlLabel
              control={<Checkbox checked={caidas12Meses} onChange={(e) => setCaidas12Meses(e.target.checked)} />}
              label="CAÍDAS EN LOS ÚLTIMOS 12 MESES"
            />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel
              control={<Checkbox checked={ayudaLocomocion} onChange={(e) => setAyudaLocomocion(e.target.checked)} />}
              label="AYUDA LOCOMOCIÓN"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: 2}}>
          <Grid item xs={12} md={4}>
            <TextField label="NÚMERO DE CAÍDAS" variant="outlined" fullWidth value={numCaidas} onChange={handleInputChange(setNumCaidas)}
              InputProps={{ readOnly: !caidas12Meses }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>
      </SectionCard>

      {/* Bloque 2: Historial y sistemas */}
      <SectionCard
        className="entrevista-viewer__section is-editing"
        ref={(node) => { sectionRefs.current.historial = node; }}
        sx={sectionCardSx}
      >
        <SectionHeader
          eyebrow="Bloque 2"
          title="Historial y sistemas"
          description="Registro estructurado de antecedentes, síntomas y hallazgos por sistemas."
        />

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Prótesis Articulares</Typography>
        <Grid container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={protesisArticulares} onChange={(e) => setProtesisArticulares(e.target.checked)} />} label="PRÓTESIS ARTICULARES" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={protesisRodilla} disabled={!protesisArticulares} onChange={(e) => setProtesisRodilla(e.target.checked)} />} label="RODILLA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={protesisCadera} disabled={!protesisArticulares} onChange={(e) => setProtesisCadera(e.target.checked)} />} label="CADERA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={protesisHombro} disabled={!protesisArticulares} onChange={(e) => setProtesisHombro(e.target.checked)} />} label="HOMBRO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={protesisManoDedos} disabled={!protesisArticulares} onChange={(e) => setProtesisManoDedos(e.target.checked)} />} label="MANOS O DEDOS" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="OTROS" variant="outlined" fullWidth value={protesisOtros} onChange={handleInputChange(setProtesisOtros)}
              InputProps={{ readOnly: !protesisArticulares }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Vértigos o mareos</Typography>
        <Grid container spacing={1} sx={{ marginBottom: 2 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={vertigos} onChange={(e) => setVertigos(e.target.checked)} />} label="VÉRTIGOS" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={mareosAndar} onChange={(e) => setMareosAndar(e.target.checked)} />} label="MAREOS AL ANDAR" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema cardiovascular</Typography>
        <Grid container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={cardiovascular} onChange={(e) => setCardiovascular(e.target.checked)} />} label="SISTEMA CARDIOVASCULAR" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={hipertension} disabled={!cardiovascular} onChange={(e) => setHipertension(e.target.checked)} />} label="HIPERTENSIÓN" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={insuficienciaCardiaca} disabled={!cardiovascular} onChange={(e) => setInsuficienciaCardiaca(e.target.checked)} />} label="INSUFICIENCIA CARDIACA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={accCerebrovascular} disabled={!cardiovascular} onChange={(e) => setAccCerebrovascular(e.target.checked)} />} label="ACC. CEREBROVASCULAR" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={anginaPecho} disabled={!cardiovascular} onChange={(e) => setAnginaPecho(e.target.checked)} />} label="ANGINA DE PECHO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={infarto} disabled={!cardiovascular} onChange={(e) => setInfarto(e.target.checked)} />} label="INFARTO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={trombosis} disabled={!cardiovascular} onChange={(e) => setTrombosis(e.target.checked)} />} label="TROMBOSIS" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="OTROS" variant="outlined" fullWidth value={otrosCardiovascular} onChange={handleInputChange(setOtrosCardiovascular)}
              InputProps={{ readOnly: !cardiovascular }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema respiratorio</Typography>
        <Grid container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={respiratorio} onChange={(e) => setRespiratorio(e.target.checked)} />} label="SISTEMA RESPIRATORIO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={asma} disabled={!respiratorio} onChange={(e) => setAsma(e.target.checked)} />} label="ASMA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={epoc} disabled={!respiratorio} onChange={(e) => setEpoc(e.target.checked)} />} label="EPOC" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="OTROS" variant="outlined" fullWidth value={otrosRespiratorio} onChange={handleInputChange(setOtrosRespiratorio)}
              InputProps={{ readOnly: !respiratorio }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema Genitourinario</Typography>
        <Grid container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={genitoUrinario} onChange={(e) => setGenitoUrinario(e.target.checked)} />} label="SISTEMA GENITOURINARIO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={infeccionUrinaria} disabled={!genitoUrinario} onChange={(e) => setInfeccionUrinaria(e.target.checked)} />} label="INFECCIÓN URINARIA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={calculosRenales} disabled={!genitoUrinario} onChange={(e) => setCalculosRenales(e.target.checked)} />} label="CÁLCULOS RENALES" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={insuficienciaRenal} disabled={!genitoUrinario} onChange={(e) => setInsuficienciaRenal(e.target.checked)} />} label="INSUFICIENCIA RENAL" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={incontinenciaUrinaria} disabled={!genitoUrinario} onChange={(e) => setIncontinenciaUrinaria(e.target.checked)} />} label="INCONTINENCIA URINARIA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={prostata} disabled={!genitoUrinario} onChange={(e) => setProstata(e.target.checked)} />} label="PRÓSTATA" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="OTROS" variant="outlined" fullWidth value={otrosGenitoUrinario} onChange={handleInputChange(setOtrosGenitoUrinario)}
              InputProps={{ readOnly: !genitoUrinario }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema Endocrino</Typography>
        <Grid container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={endocrino} onChange={(e) => setEndocrino(e.target.checked)} />} label="SISTEMA ENDOCRINO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={diabetes} disabled={!endocrino} onChange={(e) => setDiabetes(e.target.checked)} />} label="DIABETES" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={hipotiroidismo} disabled={!endocrino} onChange={(e) => setHipotiroidismo(e.target.checked)} />} label="HIPOTIROIDISMO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={hipercolesterolemia} disabled={!endocrino} onChange={(e) => setHipercolesterolemia(e.target.checked)} />} label="HIPERCOLESTEROLEMIA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={osteoporosis} disabled={!endocrino} onChange={(e) => setOsteoporosis(e.target.checked)} />} label="OSTEOPOROSIS" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="OTROS" variant="outlined" fullWidth value={otrosEndocrino} onChange={handleInputChange(setOtrosEndocrino)}
              InputProps={{ readOnly: !endocrino }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema Digestivo</Typography>
        <Grid container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={digestivo} onChange={(e) => setDigestivo(e.target.checked)} />} label="SISTEMA DIGESTIVO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={herniaHiato} disabled={!digestivo} onChange={(e) => setHerniaHiato(e.target.checked)} />} label="HERNIA DE HIATO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={reflujo} disabled={!digestivo} onChange={(e) => setReflujo(e.target.checked)} />} label="REFLUJO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={pancreatitis} disabled={!digestivo} onChange={(e) => setPancreatitis(e.target.checked)} />} label="PANCREATITIS" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={enfermedadHepatica} disabled={!digestivo} onChange={(e) => setEnfermedadHepatica(e.target.checked)} />} label="ENFERMEDAD HEPÁTICA" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={diverticulitis} disabled={!digestivo} onChange={(e) => setDiverticulitis(e.target.checked)} />} label="DIVERTICULITIS" />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="OTROS" variant="outlined" fullWidth value={otrosDigestivo} onChange={handleInputChange(setOtrosDigestivo)}
              InputProps={{ readOnly: !digestivo }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>
      </SectionCard>

      {/* Bloque 3: Medicación y seguimiento */}
      <SectionCard
        className="entrevista-viewer__section is-editing"
        ref={(node) => { sectionRefs.current.medicacion = node; }}
        sx={sectionCardSx}
      >
        <SectionHeader
          eyebrow="Bloque 3"
          title="Medicación y seguimiento"
          description="Estado musculoesquelético, sistema nervioso, medicación y actividades del programa."
        />

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema Musculoesquelético</Typography>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={musculoEsqueletico} onChange={(e) => setMusculoEsqueletico(e.target.checked)} />} label="SISTEMA MUSCULOESQUELÉTICO" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={pieTobillo} disabled={!musculoEsqueletico} onChange={(e) => setPieTobillo(e.target.checked)} />} label="PIE Y TOBILLO" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={rodilla} disabled={!musculoEsqueletico} onChange={(e) => setRodilla(e.target.checked)} />} label="RODILLA" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={cadera} disabled={!musculoEsqueletico} onChange={(e) => setCadera(e.target.checked)} />} label="CADERA" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={lumbar} disabled={!musculoEsqueletico} onChange={(e) => setLumbar(e.target.checked)} />} label="LUMBAR" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={dorsal} disabled={!musculoEsqueletico} onChange={(e) => setDorsal(e.target.checked)} />} label="DORSAL" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={cervical} disabled={!musculoEsqueletico} onChange={(e) => setCervical(e.target.checked)} />} label="CERVICAL" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={cabeza} disabled={!musculoEsqueletico} onChange={(e) => setCabeza(e.target.checked)} />} label="CABEZA" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={hombro} disabled={!musculoEsqueletico} onChange={(e) => setHombro(e.target.checked)} />} label="HOMBRO" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={codo} disabled={!musculoEsqueletico} onChange={(e) => setCodo(e.target.checked)} />} label="CODO" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={manoMunieca} disabled={!musculoEsqueletico} onChange={(e) => setManoMunieca(e.target.checked)} />} label="MANO Y MUÑECA" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema Nervioso</Typography>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={nervioso} onChange={(e) => setNervioso(e.target.checked)} />} label="SISTEMA NERVIOSO" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={depresion} disabled={!nervioso} onChange={(e) => setDepresion(e.target.checked)} />} label="DEPRESIÓN" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={ansiedad} disabled={!nervioso} onChange={(e) => setAnsiedad(e.target.checked)} />} label="ANSIEDAD" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={esclerosisMultiple} disabled={!nervioso} onChange={(e) => setEsclerosisMultiple(e.target.checked)} />} label="ESCLEROSIS MÚLTIPLE" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={parkinson} disabled={!nervioso} onChange={(e) => setParkinson(e.target.checked)} />} label="PARKINSON" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={alzheimer} disabled={!nervioso} onChange={(e) => setAlzheimer(e.target.checked)} />} label="ALZHEIMER" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={deterioroCognitivo} disabled={!nervioso} onChange={(e) => setDeterioroCognitivo(e.target.checked)} />} label="DETERIORO COGNITIVO" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={neuropatiaPeriferica} disabled={!nervioso} onChange={(e) => setNeuropatiaPeriferica(e.target.checked)} />} label="NEUROPATÍA PERIFÉRICA" />
          </Grid>
          <Grid item xs={6}>
            <TextField label="OTROS" variant="outlined" fullWidth value={otrosNervioso} onChange={handleInputChange(setOtrosNervioso)}
              InputProps={{ readOnly: !nervioso }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>Sistema de los Sentidos</Typography>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={sentidos} onChange={(e) => setSentidos(e.target.checked)} />} label="SISTEMA DE LOS SENTIDOS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={hipoacusia} disabled={!sentidos} onChange={(e) => setHipoacusia(e.target.checked)} />} label="HIPOACUSIA" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={tinitus} disabled={!sentidos} onChange={(e) => setTinitus(e.target.checked)} />} label="TINITUS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={perdidaVision} disabled={!sentidos} onChange={(e) => setPerdidaVision(e.target.checked)} />} label="PÉRDIDA DE VISIÓN" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2, mt: 2 }}>Otros datos de interés</Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField label="DATOS DE INTERÉS" variant="outlined" fullWidth value={datosInteres} onChange={handleInputChange(setDatosInteres)} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={4}>
            <TextField label="NÚMERO DE ANALGÉSICOS" variant="outlined" fullWidth value={numAnalgesicos} onChange={handleInputChange(setNumAnalgesicos)} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2, mt: 2 }}>Tensión Arterial</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField label="TENSIÓN PAS" variant="outlined" fullWidth type="number" value={tensionPAS} onChange={handleInputChange(setTensionPAS)} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="TENSIÓN PAD" variant="outlined" fullWidth type="number" value={tensionPAD} onChange={handleInputChange(setTensionPAD)} sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="FRECUENCIA CARDÍACA (PMM)" variant="outlined" fullWidth type="number" value={tensionPMM} onChange={handleInputChange(setTensionPMM)} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Typography variant="subtitle1" sx={{ marginBottom: 2, mt: 2 }}>Actividades en las que participa</Typography>
        <Grid container spacing={2}>
          {ACTIVIDADES_LIST.map((actividad) => (
            <Grid item xs={12} sm={6} md={4} key={actividad}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!actividades[actividad]}
                    onChange={(e) =>
                      setActividades((prev) => ({ ...prev, [actividad]: e.target.checked }))
                    }
                  />
                }
                label={actividad}
              />
            </Grid>
          ))}
        </Grid>
        {actividadesExtras.length > 0 && (
          <Typography variant="caption" sx={{ display: "block", mt: 1 }}>
            Actividades registradas adicionales: {actividadesExtras.join(", ")}
          </Typography>
        )}
        {actividadesSeleccionadas.length > 0 && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            Actividades seleccionadas: {actividadesSeleccionadas.join(", ")}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ marginBottom: 2, mt: 2 }}>Medicación</Typography>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={medicacion} onChange={(e) => setMedicacion(e.target.checked)} />} label="MEDICACIÓN" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={antihipertensivos} disabled={!medicacion} onChange={(e) => setAntihipertensivos(e.target.checked)} />} label="ANTIHIPERTENSIVOS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={antidiabeticos} disabled={!medicacion} onChange={(e) => setAntidiabeticos(e.target.checked)} />} label="ANTIDIABÉTICOS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={estatinas} disabled={!medicacion} onChange={(e) => setEstatinas(e.target.checked)} />} label="ESTATINAS PARA EL COLESTEROL" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={anticoagulantes} disabled={!medicacion} onChange={(e) => setAnticoagulantes(e.target.checked)} />} label="ANTICOAGULANTES O ANTIAGREGANTE" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={tiroides} disabled={!medicacion} onChange={(e) => setTiroides(e.target.checked)} />} label="TTO TIROIDES" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={diuretico} disabled={!medicacion} onChange={(e) => setDiuretico(e.target.checked)} />} label="DIURÉTICO" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={analgesicos} disabled={!medicacion} onChange={(e) => setAnalgesicos(e.target.checked)} />} label="ANALGÉSICOS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={antidepresivos} disabled={!medicacion} onChange={(e) => setAntidepresivos(e.target.checked)} />} label="ANTIDEPRESIVOS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={ansioliticos} disabled={!medicacion} onChange={(e) => setAnsioliticos(e.target.checked)} />} label="ANSIOLÍTICOS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={antiosteoporoticos} disabled={!medicacion} onChange={(e) => setAntiosteoporoticos(e.target.checked)} />} label="ANTIOSTEOPORÓTICOS" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={inhalador} disabled={!medicacion} onChange={(e) => setInhalador(e.target.checked)} />} label="INHALADOR" />
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Checkbox checked={protectorEstomago} disabled={!medicacion} onChange={(e) => setProtectorEstomago(e.target.checked)} />} label="PROTECTOR DE ESTÓMAGO" />
          </Grid>
          <Grid item xs={3}>
            <TextField label="OTROS" variant="outlined" fullWidth value={otrosMedicacion} onChange={handleInputChange(setOtrosMedicacion)}
              InputProps={{ readOnly: !medicacion }} sx={textFieldSx} size="small" />
          </Grid>
        </Grid>
      </SectionCard>

      {/* Bloque 4: Entrevista final */}
      <SectionCard
        className="entrevista-viewer__section is-editing"
        ref={(node) => { sectionRefs.current.final = node; }}
        sx={sectionCardSx}
      >
        <SectionHeader
          title="Entrevista final"
          description="Variables de seguimiento al cierre del periodo de participación."
        />

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField label="CAÍDAS MESES DE PARTICIPACIÓN" variant="outlined" type="number" inputProps={{ maxLength: 2 }}
              value={caidasFinales} onChange={(e) => setCaidasFinales(e.target.value)} fullWidth sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="NÚMERO DE PASTILLAS" variant="outlined" type="number" inputProps={{ maxLength: 2 }}
              value={numPastillas} onChange={(e) => setNumPastillas(e.target.value)} fullWidth sx={textFieldSx} size="small" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="NÚMERO DE ANALGÉSICOS" variant="outlined" type="number" inputProps={{ maxLength: 2 }}
              value={numAnalgesicosFinal} onChange={(e) => setNumAnalgesicosFinal(e.target.value)} fullWidth sx={textFieldSx} size="small" />
          </Grid>
        </Grid>

        <Grid container spacing={1} sx={{ mb: 2 }}>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={cambioMedicacionFinal} onChange={(e) => setCambioMedicacionFinal(e.target.checked)} />} label="CAMBIO DE MEDICACIÓN" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={consultaMedico} onChange={(e) => setConsultaMedico(e.target.checked)} />} label="CONSULTA MÉDICO EMPEORAMIENTO" />
          </Grid>
          <Grid item xs="auto">
            <FormControlLabel control={<Checkbox checked={ingresosHospital} onChange={(e) => setIngresosHospital(e.target.checked)} />} label="INGRESOS EN HOSPITAL" />
          </Grid>
        </Grid>

        <TextField
          label="DETALLES FINAL"
          multiline
          rows={4}
          fullWidth
          size="small"
          value={datosInteresFinal}
          onChange={(e) => setDatosInteresFinal(e.target.value)}
          sx={{ ...textFieldSx, "& .MuiOutlinedInput-root": { height: "auto" } }}
        />
      </SectionCard>
    </>
  );
}
